import menu from './en/menu'
import home from './en/home'
import title from './en/title'
import profile from './en/profile'
import burial from './en/burial'
import ceremony from './en/ceremony'
import guestlist from './en/guestlist'
import contacts from './en/contacts'
import pets from './en/pets'
import footer from './en/footer'
import login from './en/login'
import signup from './en/signup'
import recover from './en/recover'
import guardian from './en/guardian'
import guardians from './en/guardians'
import documents from './en/documents'
import proteges from './en/proteges'
import invitations from './en/invitations'
import addGuardian from './en/add-guardian'
import protegeAllInfo from './en/protege-all-info'
import account from './en/account'
import links from './en/links'
import speeches from './en/speeches'
import disclaimer from './en/disclaimer'
import imprint from './en/imprint'
import jumbotron from './en/jumbotron'
import photos from './en/photos'
import feedback from './en/feedback'
import videos from './en/videos'
import general from './en/general'
import print from './en/print'

const en = {
    menu,
    home,
    title,
    profile,
    burial,
    ceremony,
    guestlist,
    contacts,
    pets,
    footer,
    login,
    signup,
    recover,
    guardian,
    guardians,
    documents,
    proteges,
    invitations,
    addGuardian,
    protegeAllInfo,
    account,
    links,
    speeches,
    disclaimer,
    imprint,
    jumbotron,
    photos,
    feedback,
    videos,
    general,
    print
}

export default en



// WEBPACK FOOTER //
// ./src/assets/i18n/lang/en.js